import { PageHeaderStyles } from '~src/spacesPlatform/components/layout/PageHeaderStyles';

import { icon } from '../../common/react/Icons';

export const Icons = {

    // Remove with feature flag vizToolbarRedesignEnabled
    NotificationCenterLightWithUnseenNotifications: icon({
      name: 'notificationCenterIcon',
      img: 'user_notifications_icon_unseen_items_light.svg',
      hoverImg: 'user_notifications_icon_unseen_items_light_active.svg',
      size: 'large',
    }),

    NotificationCenterLight: icon({
      name: 'notificationCenterIcon',
      img: 'user_notifications_icon_light.svg',
      hoverImg: 'user_notifications_icon_light_active.svg',
      size: 'large',
    }),

    NotificationCenterMediumWithUnseenNotifications: icon({
      name: 'notificationCenterIcon',
      img: 'user_notifications_icon_unseen_items_medium.svg',
      hoverImg: 'user_notifications_icon_unseen_items_medium_active.svg',
      size: 'large',
      style: {
        width: PageHeaderStyles.CssVariables.cssVar(PageHeaderStyles.CssVariables.headerIconSize),
        height: PageHeaderStyles.CssVariables.cssVar(PageHeaderStyles.CssVariables.headerIconSize),
        backgroundSize: 'unset',
      }
    }),

    NotificationCenterMedium: icon({
      name: 'notificationCenterIcon',
      img: 'user_notifications_icon_medium.svg',
      hoverImg: 'user_notifications_icon_medium_active.svg',
      size: 'large',
      style: {
        width: PageHeaderStyles.CssVariables.cssVar(PageHeaderStyles.CssVariables.headerIconSize),
        height: PageHeaderStyles.CssVariables.cssVar(PageHeaderStyles.CssVariables.headerIconSize),
        backgroundSize: 'unset',
      }
    }),

    NotificationCenterWithUnseenNotifications: icon({
      name: 'notificationCenterIcon',
      img: 'user_notifications_icon_unseen_items.svg',
      hoverImg: 'user_notifications_icon_unseen_items_active.svg',
      size: 'large',
      style: {
        width: PageHeaderStyles.CssVariables.cssVar(PageHeaderStyles.CssVariables.headerIconSize),
        height: PageHeaderStyles.CssVariables.cssVar(PageHeaderStyles.CssVariables.headerIconSize),
        backgroundSize: 'unset',
      }
    }),

    NotificationCenter: icon({
      name: 'notificationCenterIcon',
      img: 'user_notifications_icon.svg',
      hoverImg: 'user_notifications_icon_active.svg',
      size: 'large',
      style: {
        width: PageHeaderStyles.CssVariables.cssVar(PageHeaderStyles.CssVariables.headerIconSize),
        height: PageHeaderStyles.CssVariables.cssVar(PageHeaderStyles.CssVariables.headerIconSize),
        backgroundSize: 'unset',
      }
    }),

    NotificationActionsMenu: icon({
      name: 'notificationActionIcon',
      img: 'actions_hover.svg',
      size: 'small',
    })
};
